(() => {
  if (window.ldDiscountBound) return;
  window.ldDiscountBound = true;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ld-discount]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy) return;
    const code = form.elements.discount.value.trim();
    if (!code) return;
    const messages = JSON.parse(document.querySelector('[data-ld-cart-messages]').textContent);
    const status = form.querySelector('[data-ld-discount-status]');
    const button = form.querySelector('button');
    form.dataset.busy = 'true';
    button.disabled = true;
    status.textContent = messages.loading;
    let message = messages.error;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const currentResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!currentResponse.ok) throw new Error();
      const current = await currentResponse.json();
      const existing = (current.discount_codes || []).filter(d => d.applicable !== false).map(d => d.code);
      for (const d of current.cart_level_discount_applications || []) if (d.type === 'discount_code') existing.push(d.title);
      const codes = [...new Set([...existing, code])];
      const response = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error();
      const match = (data.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());
      const allocations = [...(data.cart_level_discount_applications || []), ...(data.items || []).flatMap(i => (i.line_level_discount_allocations || []).map(a => a.discount_application))];
      const allocated = allocations.some(d => d.title?.toLowerCase() === code.toLowerCase());
      message = match?.applicable === false ? messages.invalid : match?.applicable || allocated ? messages.success : messages.pending;
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.renderContents && data.sections?.['cart-drawer'] && data.sections?.['cart-icon-bubble']) drawer.renderContents(data);
    } catch (_) {
      message = messages.error;
    } finally {
      const activeForm = document.querySelector('[data-ld-discount]') || form;
      activeForm.querySelector('[data-ld-discount-status]').textContent = message;
      activeForm.elements.discount.value = code;
      activeForm.querySelector('button').disabled = false;
      delete activeForm.dataset.busy;
      activeForm.elements.discount.focus({ preventScroll: true });
    }
  });
})();
